import { render, staticRenderFns } from "./cropzoomImg.vue?vue&type=template&id=2cd65c7f&"
import script from "./cropzoomImg.vue?vue&type=script&lang=js&"
export * from "./cropzoomImg.vue?vue&type=script&lang=js&"
import style0 from "./cropzoomImg.vue?vue&type=style&index=0&id=2cd65c7f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports